module.exports = __webpack_public_path__ + "static/speech-bubble-cc261806e08490f9f61948edc2a754b3.png";